import React, { useEffect, useState } from 'react';
import { Breadcrumbs, FileUploader, Input, Multiselect } from '@cokitchen/cokitchen-components';
import PageHeaderText from 'components/base/page-header-text';
import useCreateDealContext from 'contexts/create-deal.context';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import { Editor, EditorState } from 'react-draft-wysiwyg';
import './styles.scss';
import { EditorState as DraftEditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { ContentState, convertFromHTML, convertToRaw } from 'draft-js';
import useDashboardContext from 'contexts/dashboard.context';

const CreateDealDetails = () => {
  const [textEditorState, setTextEditorState] = useState<EditorState>();
  const { createDealForm, setCreateDealForm, handleChange, setDisabled, images, setImages } =
    useCreateDealContext();
  const { cokitchens } = useDashboardContext();
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) as string;

  const breadcrumbs = [
    { name: 'Deals & Discount', path: ROUTE_KEYS.DEALS_AND_DISCOUNTS },
    { name: 'New Deal & Discount', path: ROUTE_KEYS.CREATE_DEAL }
  ];

  const handleEditorStateChange = (e: EditorState) => {
    setTextEditorState(e);
    setCreateDealForm({
      ...createDealForm,
      body: JSON.stringify(draftToHtml(convertToRaw(e.getCurrentContent())))
    });
  };

  useEffect(() => {
    if (
      !createDealForm.heading ||
      !createDealForm.title ||
      !createDealForm.body ||
      !images.length ||
      !createDealForm.cokitchen_ids.length
    ) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [createDealForm]);

  useEffect(() => {
    if (createDealForm.body) {
      let body;
      try {
        body = convertFromHTML(JSON.parse(createDealForm.body)).contentBlocks;
      } catch (error) {
        return;
      }
      setTextEditorState(
        DraftEditorState.createWithContent(ContentState.createFromBlockArray(body))
      );
    }
  }, []);
  return (
    <div className='mx-10 pt-8 max-w-[700px]'>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className='mt-8'>
        <PageHeaderText
          title='Create Deal & Discount'
          description='Create a new deal lorem dolum ipsum'
        />
      </div>
      <Input
        type='text'
        label='Post heading'
        name='heading'
        value={createDealForm.heading}
        onChange={(e) => handleChange(e)}
        className='mb-6'
        placeholder='Post heading'
        inputClass='h-[50px]'
      />
      <Input
        type='text'
        label='Post title'
        name='title'
        value={createDealForm.title}
        onChange={(e) => handleChange(e)}
        className='mb-6'
        placeholder='Eat Good, Pay Less.'
        inputClass='h-[50px]'
      />
      <p className='text-black mb-1.5'>Post body</p>
      <Editor
        editorState={textEditorState}
        toolbarClassName='toolbarClassName'
        wrapperClassName='wrapperClassName'
        editorClassName='editorClassName'
        onEditorStateChange={handleEditorStateChange}
        placeholder="You Know how you buy a really awesome gift for someone and you're just so excited out of your shoes for the person to experience it? 🤭 Think that, think Red Pepper! 🌶️📸
with ❤️"
      />
      <p className='font-medium mt-5'>Add post image</p>
      <FileUploader
        className='p-0 border-0'
        token={token}
        setFileUrls={(urls) => {
          setImages(urls);
        }}
        fileUrls={images}
      />
      <div>
        <label className='font-medium'>Location</label>
        <Multiselect
          placeholder='Select Location(s)'
          values={createDealForm.cokitchen_ids}
          options={cokitchens.map((c) => ({
            text: c.name,
            value: c.id
          }))}
          hasSearch
          filterResults
          onChange={(cokitchen_ids) =>
            setCreateDealForm({
              ...createDealForm,
              cokitchen_ids,
              brands: [],
              meal_ids: []
            })
          }
        />
      </div>
    </div>
  );
};

export default CreateDealDetails;
